<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-title"><a id="page_vii">C<span class="small">ONTENTS</span></a></p><a id="page_vii">
</a><p class="toc"><a id="page_vii"></a><a href="#/xhtml/06_Acknowledgement">Acknowledgments</a></p>
<p class="tocb"><a href="#/xhtml/07_Abbreviations">List of Abbreviations</a></p>
<p class="tocb"><a href="#/xhtml/10_Introduction">Introduction</a></p>
<p class="toc-h"><span href="#/xhtml/11_Chapter01" title="Link target outside of Sample"><b>1</b>  Competitive Memory in the Great Lakes: Touring Genocide</span></p>
<p class="toc-h"><span href="#/xhtml/12_Chapter02" title="Link target outside of Sample"><b>2</b>  Marketing Trauma and the Theatre of War in Northern Uganda</span></p>
<p class="toc-h"><span href="#/xhtml/13_Chapter03" title="Link target outside of Sample"><b>3</b>  Trauma, Inc. in Postgenocide Rwanda</span></p>
<p class="toc-h"><span href="#/xhtml/14_Chapter04" title="Link target outside of Sample"><b>4</b>  Repetition, Rupture, and <i>Ruined</i>: Narratives from the Congo</span></p>
<p class="toc-h"><span href="#/xhtml/15_Chapter05" title="Link target outside of Sample"><b>5</b>  Gifted by Trauma: The Branding of Postconflict Northern Uganda</span></p>
<p class="toc-h"><span href="#/xhtml/16_Chapter06" title="Link target outside of Sample"><b>6</b>  Confessions of a Failed Theatre Activist</span></p>
<p class="tocb"><span href="#/xhtml/17_Afterword" title="Link target outside of Sample">Afterword: Faustin Linyekula and the Labors of Hope</span></p>
<p class="toc"><span href="#/xhtml/18_References" title="Link target outside of Sample">References</span></p>
<p class="toc"><span href="#/xhtml/19_Index" title="Link target outside of Sample">Index</span></p>
<p class="toc"><span href="#/xhtml/20_Abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?30dc050a